export const spotConstants = {
  OPEN_MODAL: "OPEN_MODAL",
  OPEN_APPREJ_MODAL: "OPEN_APPREJ_MODAL",
  SPOT_DATA_BY_ID: "SPOT_DATA_BY_ID",
  SPOT_DATA_BY_ID_NULL: "SPOT_DATA_BY_ID_NULL",
  SPOT_DATA_BY_CENTER_ID: "SPOT_DATA_BY_CENTER_ID",
  USER_APPROVAL_VIEW_MODAL: "USER_APPROVAL_VIEW_MODAL",
  PUBLIC_SPOTS: "PUBLIC_SPOTS",
  ADMIN_SPOTS_LIST: "ADMIN_SPOTS_LIST",
  ALL_APPROVED_PUBLIC_PRIVATE_SPOTS: "ALL_APPROVED_PUBLIC_PRIVATE_SPOTS",
  spotType: { PUBLIC: 0, PRIVATE: 1 },
  spotTypeMap: {
    0: "public",
    1: "private",
  },
  ALL_SPOTS: "ALL_SPOTS",
};

export const availableServicesConstants = {
  BEGINNER_LESSONS: 1,
  ADVANCED_LESSONS: 2,
  EQUIPMENT_RENTALS: 3,
  RESCUE: 4,
};

export const windDirectionsOptions = [
  { id: 1, label: "N", value: "N" },
  { id: 2, label: "W", value: "W" },
  { id: 3, label: "E", value: "E" },
  { id: 4, label: "S", value: "S" },
  { id: 5, label: "NW", value: "NW" },
  { id: 6, label: "NE", value: "NE" },
  { id: 7, label: "SW", value: "SW" },
  { id: 8, label: "SE", value: "SE" },
];

export const relativeToShoreOptions = [
  { id: 1, label: "Offshore", value: "Offshore" },
  { id: 2, label: "Onshore", value: "Onshore" },
  { id: 3, label: "Sideshore", value: "Sideshore" },
];
